const initialState = {
    loading: false,
    error: false,
    message: "",
    rawData: [],
    data: {},
    dataChart: { 
        new: { loading: false, data: null }, 
        semi: { loading: false, data: null }, 
        demos: { loading: false, data: null }, 
        hdm: { loading: false, data: null }, 
        seguros: { loading: false, data: null } ,
        postventa: { loading: false, data: null } 
    },
    select: {},
    year: 0,
    month: 0,
    type: 0,
    typeData: 0,
    vsMorD: 0,
    selectStatusChart: (JSON.parse(localStorage.getItem("selectStatusChartV3")) ||
    {
        new: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
        semi: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
        demos: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
        hdm: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
        seguros: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null },
        postventa: { idIndicator: null, group: 0, vs: 1, idBrand: [], year: null }
    })
}

export default (state = initialState, action) => {
    switch (action.type) {
        case "CHANGE_FILTER":
            return { ...state, ...action.payload }
        case "LOADING_RESUMEN_GERENCIAL":
            return { ...state, error: false, loading: action.payload };
        case "CHANGE_TYPE_RESUMEN_GERENCIAL":
            return { ...state, loading: false, error: false, type: action.payload.type, vsMorD: action.payload.vsMorD, data: action.payload.data };
        case "READY_SELECT_RESUMEN_GERENCIAL":
            return { ...state, loading: false, error: false, select: action.payload };
        case "SEARCH_DATA":
            return { ...state, loading: true }
        case "READY_DATA_RESUMEN_GERENCIAL":
            return { ...state, loading: false, error: false, data: action.payload.data, rawData: action.payload.rawData };
        case "ERROR_RESUMEN_GERENCIAL":
            return { ...state, loading: false, error: true, message: action.payload };
        case "CHANGE_TYPE_DATA_RESUMEN_GERENCIAL":
            return { ...state, loading: false, error: false, typeData: action.payload };
        case "LOADING_CHART_RESUMEN_GERENCIAL":
            return { ...state, dataChart: { ...state.dataChart, [action.payload.type]: { ...state.dataChart[action.payload.type], data: null, loading: action.payload.loading } } };
        case "READY_DATA_CHART_RESUMEN_GERENCIAL":
            return { ...state, dataChart: { ...state.dataChart, [action.payload.type]: { ...state.dataChart[action.payload.type], data: action.payload.data, loading: false } } };
        case "CHANGE_SELECT_CHART_RESUMEN_GERENCIAL":
            return { ...state, selectStatusChart: { ...state.selectStatusChart, [action.payload.type]: { ...state.selectStatusChart[action.payload.type], [action.payload.select]: action.payload.value } } };
        default:

    }
    return state;
}